// extracted by mini-css-extract-plugin
export default {"container":"container-UFf9k5s9"};